module.exports = __webpack_public_path__ + "static/img/P3.f659625.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qdzy/P3.png
// module id = jeow
// module chunks = 0